import {Component} from "@angular/core";

@Component({
  selector: "app-login-main",
  template: `<div [style.background-image]="'url(/assets/img/login-bg.png)'"
                [style.background-size]="'cover'">
    <router-outlet></router-outlet>
  </div>`
})
export class LoginMainComponent {
}
